import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { http } from "../auth";
import { Row, Col, Form, Button } from "react-bootstrap";
import { telefonos, natural, juridico } from "../utils/bancos";
import { useThemeManager } from "../Hooks/ThemeManager";

const BdvIpg = ({ id_doc, id_servicio, factura, abonar, onBankChange }) => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const customId = "custom-id-yes";
  const token = localStorage.getItem("token");
  const [origin, setOrigin] = useState("V");
  const [isNatural, setIsNatural] = useState(true);
  const [ci, setCi] = useState("");
  const [telefono, setTelefono] = useState([]);
  const [loading, setLoading] = useState(false);
  const [taxPayer, setTaxPayer] = useState("N");
  const { themeColors } = useThemeManager();

  const bankRef = useRef(false);

  useEffect(() => {
    // Banco de Venezuela es el único banco en este componente
    const nombreBanco = "Banco de Venezuela";

    if (onBankChange && !bankRef.current) {
      bankRef.current = true;
      onBankChange(nombreBanco);
    }
  }, [onBankChange]);

  const handleOriginChange = (event) => {
    const value = event.target.value;
    setOrigin(value);
    setIsNatural(!(value === "J" || value === "G"));
  };

  const handleTaxPayer = (event) => {
    setTaxPayer(event.target.value);
  };

  const cedula = (event) => {
    const inputValue3 = event.target.value;
    const numericValue3 = inputValue3.replace(/[^0-9]/g, "");
    setCi(numericValue3.toString());
  };

  const numero = (event) => {
    const inputValue2 = event.target.value;
    const numericValue2 = inputValue2.replace(/[^0-9]/g, "");
    setTelefono(numericValue2.toString());
  };

  const onSubmit = async (data) => {
    setLoading(true);

    if (factura) {
      data.id_docs = id_doc;
      delete data.id_servicio;
    } else if (!factura) {
      data.id_servicio = id_servicio;
      delete data.id_doc;
    }

    if (taxPayer === "J") {
      data.letter_rif = data.letter_rif;
      data.number_rif = ci;
    }
    data.letter = origin;
    data.is_natural = isNatural;
    data.number = ci;
    data.phone = data.pre + telefono;
    data.bank = "Banco de Venezuela";

    if (telefono.length < 7) {
      toast.warning("Falta un número de teléfono", {
        toastId: customId,
        position: "top-center",
      });
      setLoading(false);
      return;
    }

    http
      .post("/bdv/ipg-j", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        toast.success("Redirigiendo al Banco de Venezuela.", {
          toastId: customId,
          position: "top-center",
        });
        window.location.href = response?.data?.url;
      })
      .catch((error) => {
        const errorMessages = {
          409: "No se pudo verificar el pago",
          400: "Ha ocurrido un error al procesar el pago",
          422: "El pago no se pudo procesar",
          500: "Hubo un error de conexión con el servidor, por favor inténtelo más tarde.",
        };
        const message = errorMessages[error.response?.status];
        if (message) {
          toast.error(message, {
            toastId: customId,
            position: "top-center",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <span className="center-all header-bill mt-4">Datos del pagador</span>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-pago border-card mt-2 ">
          <div className="padding-form">
            <Row className="g-3">
              <Col xs={12}>
                <Form.Group className="mb-2">
                  <Form.Label>Tipo pagador.</Form.Label>
                  <Form.Select onChange={handleTaxPayer} className="custom-select-no-arrow">
                    <option value="N">Natural</option>
                    <option value="J">Juridico</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row className="g-4">
              <Col xs={4} sm={3} xxl={3}>
                <Form.Group className="mb-2">
                  <Form.Label>Nacionalidad</Form.Label>
                  <Form.Select onChange={handleOriginChange} className="custom-select-no-arrow align-selector">
                    {natural.map((opcion) => (
                      <option key={opcion.value} value={opcion.value}>
                        {opcion.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={8} sm={9} xxl={9}>
                <Form.Group className="mb-2">
                  <Form.Label>Cédula</Form.Label>
                  <Form.Control type="number" onChange={cedula} value={ci} />
                </Form.Group>
              </Col>
            </Row>
            <Row className="g-4">
              <Col xs={4} sm={3} xxl={3}>
                <Form.Group className="mb-2">
                  <Form.Label>Prefijo</Form.Label>
                  <Form.Select {...register("pre")} className="custom-select-no-arrow align-selector">
                    {telefonos.map((banco) => (
                      <option key={banco.value} value={banco.value}>
                        {banco.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={8} sm={9} xxl={9}>
                <Form.Group className="mb-2">
                  <Form.Label>Número teléfonico</Form.Label>
                  <Form.Control type="text" onChange={numero} value={telefono} maxLength="7" />
                </Form.Group>
              </Col>
            </Row>
            {taxPayer === "J" && (
              <>
                <div className="text-center m-2">
                  <span>
                    <strong>Datos del RIF</strong>
                  </span>
                </div>
                <Row className="g-3">
                  <Col xs={4} sm={3}>
                    <Form.Group className="mb-2">
                      <Form.Label>Tipo Doc.</Form.Label>
                      <Form.Select {...register("letter_rif")} className="custom-select-no-arrow align-selector">
                        {(taxPayer === "N" ? natural : juridico).map((opcion) => (
                          <option key={opcion.value} value={opcion.value}>
                            {opcion.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={8} sm={9}>
                    <Form.Group className="mb-2">
                      <Form.Label>Número de RIF</Form.Label>
                      <Form.Control {...register("number_rif")} />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </div>
        <Button type="submit" className="pay-btn">
          {loading ? (
            <>
              <div className="spinner"></div>
            </>
          ) : (
            <span>Pagar</span>
          )}
        </Button>
      </form>
    </div>
  );
};

export default BdvIpg;